<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="Racing the Rain: A Novel, by John L Parker." class="imagefp" src="images/9781476769875.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?2d1b70bc